import './globals';
import {App} from './src/App';
console.disableYellowBox = true;
console.log = () => { };
console.warn = () => { };
console.info = () => { };
export default App;
